// extracted by css-extract-rspack-plugin
export default {"tags":"Y1vjAYmqUeoS2WIb","removedTag":"VL0mWyfbdUMjPzpB"};